export default __webpack_public_path__ + "static/media/Mask Group 6.c999483f.png";